import React, { useEffect, useRef, useState, useLayoutEffect, useCallback } from "react";
import axios from "../../Hook/utils/constants/server";
import { useSearchParams, useLocation, useNavigate, createSearchParams, Routes, Route } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import TableList from "../../Hook/list";
import Countries from "../Data/countries/countries.json";
import useTable from "../../Hook/useTable";
import Pagination from "../../Hook/list/listfooter";
// import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { enqueueSnackbar } from "notistack";
import Calendar from "react-calendar";
import "../../../src/Hook/CustomHook.css";
import useSearchParamsState from "../../Hook/useSearchparamsstate";
import "./index.scss";
import StoreDetail from "./storedetail";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

let pageValue;
let countries = [{ name: "All", flag: "" }].concat(Countries.map(country => ({ flag: country.code.toLowerCase(), name: country.name })));
const ReportsScreen = () => {
    const location = useLocation();
    const appName = (window.localStorage.getItem("activeApp"))? window.localStorage.getItem("activeApp"):'Wishlist Guru';
    const [searchParamsState, setSearchParamsState] = useSearchParamsState();
    const [page, setPage] = useState(searchParamsState.get("pageNumber") ? Number(searchParamsState.get("pageNumber")) : 1);
    const inputSearch = useRef(null);
    const searchCountry = useRef(null);
    const calenderDate = useRef(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const navigation = useNavigate();
    const [filters, setFilters] = useState({
        loader: false,
        list: [],
        listCount: [],
        defaultPage: searchParamsState.get("pageNumber") ? searchParamsState.get("pageNumber") : 1,
        status: {
            default: searchParamsState.get("status") ? searchParamsState.get("status") : "all",
            list: ["all", "Active", "inActive"],
            triger: false
        },
        store_type: {
            default: searchParamsState.get("store_type") ? searchParamsState.get("store_type") : "all",
            list: ["all", "live", "testing"],
            triger: false
        },
        setup: {
            default: searchParamsState.get("setup_completed") ? searchParamsState.get("setup_completed") : "both",
            list: ["both", "true", "false"],
            triger: false
        },
        recordsPerpagedropdown: {
            defaultValue: searchParamsState.get("frequency_count") ? searchParamsState.get("frequency_count") : 50,
            list: [50, 100, 250, 500],
            menuOpen: false,
        },
        dates: {
            date: searchParamsState.get("start_date") && searchParamsState.get("end_date") ? [`${searchParamsState.get("start_date")}`, `${searchParamsState.get("end_date")}`] : ['', ''],
            showCalendar: false,
            triger: false
        },
        countries: {

            list: countries,
            selectedCountry: {
                flag: searchParamsState.get("country") ? `${countries.find(country => country.name === searchParamsState.get("country")).flag}` : "",
                name: searchParamsState.get("country") ? searchParamsState.get("country") : "All"
            },
            triger: false
        },
        planname: {
            default: { label: searchParamsState.get("plan") ? searchParamsState.get("plan") : "All", value: "all" },
            list: [{
                label: "All",
                value: "All"
            }, { label: "Basic", value: "basic" }, { label: "Premium", value: "premium" }, { label: "Free", value: "free" }, { label: "Pro", value: "pro" }],
            triger: false
        }, 
        search: {
            value: searchParamsState.get("search") ? searchParamsState.get("search") : "",
            enabled: searchParamsState.get("search") ? true : false
        },
        theme: {
             value: searchParamsState.get("theme") ? searchParamsState.get("theme") : "",
            enabled: searchParamsState.get("theme") ? true : false
        },
        shopifyPlan: {
            default: { label: "All", value: "all" },
            list: [
                { label: "All", value: "all" },
                { label: "All Active", value: "all_active" },
                { label: "Basic", value: "basic" },
                { label: "Grow", value: "grow" },
                { label: "Shopify Plus", value: "shopify_plus" },
                { label: "Unlimited", value: "unlimited" },
                { label: "Partner Test", value: "partner_test" },
                { label: "Development", value: "development" },
                { label: "Professional", value: "professional" },
                { label: "Inactive", value: "inactive" },
            ],
            triger: false
        },
        review: {
            default: searchParamsState.get("review") ? searchParamsState.get("review") : "all",
            list: ["all", "yes", "no"],
            triger: false
        }
    });
    const [tableList, setTableList] = useState({
        thead: [
   
            {
                type: "text",
                title: "Date",
                key: "date"
            },
      
            {
                type: "link",
                title: "Store Name",
                element: {
                    type: "view",
                    key: "store_name",
                    url: "shop_name",
                },
            },
            {
                type: "text",
                title: "Active Plan",
                key: "active_plan_name"
            },
         
          
            {
                type: "text",
                title: "SetUp Completed",
                key: "setup_completed"
            },
 
          {
                type: "text",
                title: "Shopify Plan",
                key: "shopify_plan"
            },
            { type: "text", title: "Review", key: "review" },
            {
                type: "action",
                title: "Action",
                element: [{
                    type: "view", icon: <FaEye color="#f5aa33" />,
                    
                     action: (e, id) => {
                      e.preventDefault();
                      const url = `/dashboard/reports/details?id=${id}`;
                      window.open(url, "_blank");
                    }
                }]
            }
        ],
        tbody: [],
        tbodycopy: []
    });
 
    const handleInputSearch = e => {
   
        if (e.target.value === "") {
            // console.log("inside the empty case");
            setFilters({ ...filters, search: { ...filters.search, value: "" } })
            // setTableList({ ...tableList, tbody: tableList.tbodycopy });
        }
        else if (e.target.value === "") {
            setFilters({ ...filters, search: { ...filters.search, value: "" } })
        }
        else if (e.target.value !== "") {
            // console.log("babaji")
            setFilters({ ...filters, search: { ...filters.search, value: e.target.value, enabled: true } })
        }
    };

   const handleInputTheme = (e) => {
    const value = e.target.value;

    if (value === "") {
        setFilters({
            ...filters,
            theme: {
                ...filters.theme,
                value: "",
                enabled: false,
                triger: true
            }
        });
    } else {
        setFilters({
            ...filters,
            theme: {
                ...filters.theme,
                value,
                enabled: true,
                triger: true
            }
        });
    }
};

    const handleFilterSearch = async () => {
      
        // setFilters({ ...filters, search: { ...filters.search, enabled: true } });
        let statePairs = {};
        if (!filters.countries.triger && !filters.dates.triger && !filters.planname.triger && !filters.setup.triger && !filters.status.triger && !filters.store_type.triger && !filters.shopifyPlan.triger && !filters.review.triger && !filters.search.value !== "" && filters.search.enabled === false && (filters.search.enabled && filters.search.value === "")) {
            return;
        }
        else if (filters.countries.triger || filters.dates.triger || filters.planname.triger || filters.setup.triger || filters.status.triger || filters.store_type.triger || filters.shopifyPlan.triger || filters.review.triger || filters.search.value !== "" || filters.search.enabled || filters.theme.value !== "") {
            // console.log(inputSearch.current.value)
            if (filters.countries.triger) {
                // console.log()
                statePairs["country"] = filters.countries.selectedCountry.name
            }
            if (filters.dates.triger) {
                if (filters.dates.date[0] !== "")
                    statePairs["start_date"] = filters.dates.date[0];
                if (filters.dates.date[1] !== "")
                    statePairs["end_date"] = filters.dates.date[1];
                if (filters.dates.date[0] === "") {
                    
                    statePairs["start_date"] = ""
                }
                if (filters.dates.date[1] === "") {
                  
                    statePairs["end_date"] = ""
                }
            }
            if (filters.setup.triger) {
                statePairs["setup_completed"] = filters.setup.default
            }
            if (filters.planname.triger) {
                statePairs["plan"] = filters.planname.default.label
            }
            if (filters.shopifyPlan.triger) {
                statePairs["shopify_plan"] = filters.shopifyPlan.default.value
            }
            if (filters.review.triger) {
                statePairs["review"] = filters.review.default
            }
            if (filters.status.triger) {
                statePairs["status"] = filters.status.default
            }
            if (filters.store_type.triger) {

                statePairs["store_type"] = filters.store_type.default
            }
            if (filters.search.value !== "") {
                statePairs["search"] = filters.search.value;
            }
            if (filters.search.value === "") {
             
                statePairs["search"] = ""
            }

            if (filters.theme.value !== "") {
                statePairs["theme"] = filters.theme.value;
            }
            if (filters.theme.value === "") {
             
                statePairs["theme"] = ""
            }
          
             
            setSearchParamsState({ ...statePairs });
            setFilters({
                ...filters, loader
                    : true
            })
        
            let response = await axios.get("/user/reports", {
                method: 'GET',
                params: {
                    // pageNumber: filters.defaultPage,
                    pageNumber: searchParamsState.get("pageNumber") ? searchParamsState.get("pageNumber") : 1,
                    recordsPerpage: filters.recordsPerpagedropdown.defaultValue,
                    status: filters.status.default,
                    setup_completed: filters.setup.default,
                    store_type: filters.store_type.default,
                    country_name: filters.countries.selectedCountry.name,
                    start_date: filters.dates.date[0],
                    end_date: filters.dates.date[1],
                    plan: filters.planname.default.label,
                    search: filters.search.value,
                    theme: filters.theme.value,
                    shopify_plan: filters.shopifyPlan.default.value,
                    review: filters.review.default
                },
                 headers: {
                    "Content-Type": "application/json",
                    "x-app-name": appName,
                }
            });
            if (response.data === "jwt expired" || response.data === "jwt must be provided") {
                navigation("/");
                localStorage.clear();
                enqueueSnackbar("Token expired ,please login again to continue", {
                    variant: "info",
                    autoHideDuration: 2000,
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "right"
                    }
                })
            }
            else if (response.data.data) {
                 console.log("page", response.data.data.recordCount)
                setSearchParamsState({ ...statePairs, pageNumber: response.data.data.maxPage })
                setFilters({ ...filters, search: { ...filters.search, enabled: true }, loader: false, listCount: response.data.data.recordCount });
                setTableList({ ...tableList, tbody: modifyData(response.data.data.list), tbodycopy: modifyData(response.data.data.list) })
                setTotalRecords(response.data.data.recordCount)
            }
            //console.log(tableList, 'tableListtableListtableList')
            //console.log(response, 'responseresponse')
        }
    }
    const handleCountrySearch = e => {
        searchCountry.current.value = e.currentTarget.value;
        if (e.key === "Backspace" && searchCountry.current.value === "") {
            setFilters({
                ...filters, countries: {
                    ...filters.countries, list: countries
                }
            })
        }
        else if (e.key === "Backspace" && searchCountry.current.value !== "") {
            setFilters({
                ...filters, countries: {
                    ...filters.countries, list: Countries.filter(country => {
                        if (country.name.toLowerCase().includes(searchCountry.current.value.toLowerCase()) || country.name === searchCountry.current.value)
                            return country

                    }).map(country => ({
                        flag: country.code.toLowerCase(),
                        name: country.name
                    }))
                }
            })
        }
        else {
            setFilters({
                ...filters, countries: {
                    ...filters.countries, list: Countries.filter((country) => {
                        if (country.name.toLowerCase().includes(searchCountry.current.value.toLowerCase()) || country.name === searchCountry.current.value) {
                            return country
                        }
                    }
                    ).map(country => ({
                        flag: country.code.toLowerCase(),
                        name: country.name
                    }))
                }
            });
        }
     }

    const modifyData = data => {
        return data.map((data, index) => {
                 const dateObj = new Date(data.date);

                const day = String(dateObj.getDate()).padStart(2, '0');
                const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                const year = dateObj.getFullYear();

                const hours = String(dateObj.getHours()).padStart(2, '0');
                const minutes = String(dateObj.getMinutes()).padStart(2, '0');
                const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    
            return {
                serial: index + 1,
                ...data,
                date: `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`,
            };
        });
    }
       

    const onPageChange = (e, pageNumber) => {
        setPage(pageNumber);
        pageValue = pageNumber;
        setSearchParamsState({ pageNumber: pageNumber })
    }
    const positive = (e, id) => {
        navigation({
            pathname: "/dashboard/reports/details",
            search: createSearchParams({ id }).toString(),

        });
    }
    const handleDateChange = e => {
        let dateSets = e.map(date => `${new Date(date).getFullYear()}-${new Date(date).getMonth() + 1}-${new Date(date).getDate()}`);
        setFilters((filters) => ({ ...filters, dates: { ...filters.dates, date: [...dateSets], showCalendar: !filters.dates.showCalendar, triger: true } }));
        // setFilters({ ...filters, dates: { ...filters.dates, date: [...dateSets], showCalender: !filters.dates.showCalendar, triger: true } });
    }
    const changeRecordsPerpage = (e, count) => {
        setFilters({ ...filters, recordsPerpagedropdown: { ...filters.recordsPerpagedropdown, defaultValue: count } });
        setSearchParamsState({ frequency_count: count })
    }
    const { slicedData, tablerange } = useTable(filters.list, filters.listCount, page, filters.recordsPerpagedropdown.defaultValue);
    React.useEffect(() => {
        let list = [...searchParamsState.entries()];
        if (tablerange.length === 0) {
            if (searchParamsState.get("pageNumber")) {
                pageValue = Number(searchParamsState.get("pageNumber"));
            }
            else {
                pageValue = 1;
            }
        }
        else if (tablerange.length > 0) {
            if (searchParamsState.get("pageNumber")) {
                if (tablerange[tablerange.length - 1] < searchParamsState.get("pageNumber")) {
                    // console.log("check")
                    pageValue = Number(tablerange[tablerange.length - 1]);
                    setSearchParamsState({ pageNumber: pageValue });
                }
                else if (tablerange[tablerange.length - 1] > searchParamsState.get("pageNumber")) {
                    // console.log("second")
                    pageValue = Number(searchParamsState.get("pageNumber"));
                    setSearchParamsState({ pageNumber: pageValue })
                }
                else if (tablerange[tablerange.length - 1] == (searchParamsState.get("pageNumber"))) {
                    // console.log("Positive")
                    pageValue = Number(searchParamsState.get("pageNumber"));
                    setSearchParamsState({ pageNumber: pageValue })
                }
            }
            else {
                pageValue = 1;
                setSearchParamsState({ pageNumber: pageValue })
            }
        }
        if (list.length === 1 && list[0][0].includes("pageNumber") || list.length === 0) {
            setFilters((filters) => ({ ...filters, loader: true }));
            //console.log("Poisitivevhvghfb22222222222")
            axios.get("/user/reports", {
                method: "GET",
                params: {
                    recordsPerpage: filters.recordsPerpagedropdown.defaultValue,
                    pageNumber: pageValue,
                    status: searchParamsState.get("status"),
                    store_type: searchParamsState.get("store_type"),
                    country_name: searchParamsState.get("country"),
                    setup_completed: searchParamsState.get("setup_completed"),
                    start_date: searchParamsState.get("start_date"),
                    end_date: searchParamsState.get("end_date"),
                    plan: searchParamsState.get("plan"),
                    search: searchParamsState.get("search"),
                    theme: searchParamsState.get("theme"),
                    shopify_plan: searchParamsState.get("shopify_plan"),
                    review: searchParamsState.get("review")
                },
                headers: {
                    "Content-Type": "application/json",
                    "x-app-name": appName,
                }
            }).then(response => {
                if (response.data === "jwt expired" || response.data === "jwt must be provided") {
                    navigation("/");
                    localStorage.clear();
                    enqueueSnackbar(`${response.data} , please login to continue`, {
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "right"
                        },
                        variant: "info",
                        autoHideDuration: 2000
                    })
                }
                else {
                    setSearchParamsState({ pageNumber: response.data.data.maxPage })
                    setFilters({ ...filters, listCount: response.data.data.recordCount, loader: false });
                    setTableList({ ...tableList, tbody:  modifyData(response.data.data.list), tbodycopy: modifyData(response.data.data.list) });
                    setTotalRecords(response.data.data.recordCount)
                }
                
            }).catch(er => {
                console.log("Error", er);
                setFilters(prev => ({ ...prev, loader: false }));
                setTableList(prev => ({ ...prev, tbody: [], tbodycopy: [] }));
            })
        }
        else {
             console.log("Poisitivevhvghfb333333333333")
            axios.get("/user/reports", {
                method: 'GET',
                params: {
                    pageNumber: pageValue,
                    recordsPerpage: filters.recordsPerpagedropdown.defaultValue,
                    status: searchParamsState.get("status"),
                    setup_completed: searchParamsState.get("setup_completed") ? searchParamsState.get("setup_completed") : null,
                    store_type: searchParamsState.get("store_type") ? searchParamsState.get("store_type") : null,
                    country_name: searchParamsState.get("country") ? searchParamsState.get("country") : null,
                    start_date: searchParamsState.get("start_date") ? searchParamsState.get("start_date") : null,
                    end_date: searchParamsState.get("end_date") ? searchParamsState.get("end_date") : null,
                    plan: searchParamsState.get("plan") ? searchParamsState.get("plan") : null,
                    search: searchParamsState.get("search"),
                    theme: searchParamsState.get("theme"),
                    shopify_plan: searchParamsState.get("shopify_plan") ? searchParamsState.get("shopify_plan") : null,
                    review: searchParamsState.get("review") ? searchParamsState.get("review") : null
                },
                 headers: {
                    "Content-Type": "application/json",
                    "x-app-name": appName,
                }
            }).then(response => {
                if (response.data === "jwt expired" || response.data === "jwt must be provided") {
                    localStorage.clear();
                    navigation("/");
                    enqueueSnackbar(`${response.data} , please login to continue`, {
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "right"
                        },
                        variant: "info",
                        autoHideDuration: 2000
                    })
                }
                else {
                    setSearchParamsState({ pageNumber: response.data.data.maxPage })
                    setFilters({ ...filters, listCount: response.data.data.recordCount });
                    setTableList({ ...tableList, tbody: modifyData(response.data.data.list), tbodycopy: modifyData(response.data.data.list) });
                    setTotalRecords(response.data.data.recordCount)
                }

                
            }).catch((error) => {
      console.error("API call failed======:", error);
      if(error.response?.status === 401){
          navigation("/");
          localStorage.clear();
      }
      setFilters(prev => ({ ...prev, loader: false }));
      setTableList(prev => ({ ...prev, tbody: [], tbodycopy: [] }));
    }).finally(positive => positive);
        }
    }, [pageValue, filters.recordsPerpagedropdown.defaultValue]);
    const cleardatesandClose = e => {
        setFilters({ ...filters, dates: { ...filters.dates, date: ['', ''], triger: true, showCalendar: false } });
    }

    return (
        <>
            <div className="container grid-box main-container">
                <div className="mb-0 border border-white p-2 d-md-flex align-items-md-center justify-content-md-between">
                    <div>
                        <h1 style={{ color: "#f5aa33" }}>
                            Reports
                        </h1>
                    </div>
                    <div className="search-country w-50">
                        <input className="search-input w-100" defaultValue={filters.search.value} onChange={handleInputSearch} placeholder="Search by shop name or shop url or store name or store owner" />
                    </div>
                    <div className="theme-name w-25">

                        <input className="theme-input w-100" defaultValue={filters.theme.value}onChange={handleInputTheme} placeholder="Search by theme name" />
                    </div>
                </div>
                <div className="p-2 row">
                    <div className="filter-container ">
                        <div className="countries-filter filter-country dropdown d-flex flex-column">
                            <span >Sort By Country</span>
                            <button className="dropdown-toggle p-1 py-2 d-flex gap-4 rounded-2 d-flex align-items-center justify-content-between position-relative" id="dropdowncountry" aria-haspopup="true" aria-expanded="false" data-bs-toggle="dropdown" >
                                <p className="mb-0 gap-2 d-flex align-items-center" >
                                    {filters.countries.selectedCountry.name !== "All" ?
                                        <span className="image-logo">
                                            <img className="" src={`https://flagcdn.com/${filters.countries.selectedCountry.flag}.svg`} />
                                        </span> : <span className="no-logo"></span>
                                    }
                                    <span className="selected-country text-start">
                                        {filters.countries.selectedCountry.name}
                                    </span>
                                </p>
                                <span className="tool-tip position-absolute">
                                    <span className="arrow-top"></span>
                                    {filters.countries.selectedCountry.name}
                                </span>
                            </button>
                            <div className="dropdown-menu country-dropdown px-0 position-absolute" aria-labelledby="dropdowncountry" >

                                <div className="seacrh-input w-100 position-sticky top-0">
                                    <input className="w-100 p-2 search-input" onKeyUp={handleCountrySearch} ref={searchCountry} type="text" placeholder="Search by country" />
                                </div>
                                <div className="country-scroll">

                                    {filters.countries.list.length > 0 && filters.countries.list.map((country, index) => (
                                        <div className="dropdown-item p-1 d-flex align-items-center gap-2" key={index} onClick={() => {
                                            setFilters({ ...filters, countries: { ...filters.countries, selectedCountry: { ...filters.countries.selectedCountry, name: country.name, flag: country.flag }, triger: true } });
                                        }

                                        } style={{ cursor: "pointer" }}>
                                            <span className="img-container">
                                                {country.flag !== "" &&
                                                    <img className="" style={{ width: "25px", height: "25px" }} src={`https://flagcdn.com/${country.flag}.svg`} />
                                                }
                                            </span>
                                            <span className="text-muted">
                                                {country.name}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="setup-filter filter-setup dropdown d-flex flex-column">
                            <span className="fs-6" style={{ color: "#f5aa33", fontSize: "14.5px", fontWeight: 600 }}>
                                SetUp
                            </span>
                            <button style={{ color: "#f5aa33" }} className="dropdown-toggle p-1 py-2 rounded-2 d-flex align-items-center gap-4 justify-content-between" id="dropdownsetup" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {filters.setup.default === "true" && "Completed"}
                                {filters.setup.default === "both" && "Both"}
                                {filters.setup.default === "false" && "Not completed"}
                            </button>
                            <div className="dropdown-menu p-2" aria-labelledby="dropdownsetup">
                                {filters.setup.list.map((setup_completed, index) => (
                                    <div className="dropdown-item" key={setup_completed} style={{ color: filters.setup.default === setup_completed ? "#f5aa33" : "", cursor: "pointer" }} onClick={() => {
                                        setFilters({ ...filters, setup: { ...filters.setup, triger: true, default: setup_completed } });
                                    }
                                    }>
                                        {setup_completed === "true" && "Completed"}
                                        {setup_completed === "both" && "Both"}
                                        {setup_completed === "false" && "Not Completed"}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="status-filter filter dropdown d-flex flex-column">
                            <span className="fs-6" style={{ color: "#f5aa33", fontSize: "14.5px", fontWeight: 600 }}>Status</span>
                            <button style={{ color: "#f5aa33" }} className="dropdown-toggle p-1 py-2 rounded-2 d-flex gap-4 align-items-center justify-content-between" id="dropdownstatus" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {filters.status.default === "all" && "All"}
                                {filters.status.default === "Active" && "Active"}
                                {filters.status.default === "inActive" && "In Active"}
                            </button>
                            <div className="dropdown-menu p-2" aria-labelledby="dropdownstatus">
                                {filters.status.list.map((status, index) => <div style={{ color: filters.status.default === status ? "#f5aa33" : "", cursor: "pointer" }} className="dropdown-item" key={index} onClick={() => {
                                    setFilters({ ...filters, status: { ...filters.status, default: status, triger: true } });
                                }}>
                                    {status === "all" && "All"}
                                    {status === "inActive" && "InActive"}
                                    {status === "Active" && "Active"}
                                </div>)}
                            </div>
                        </div>
                        <div className="store-type-filter filter dropdown d-flex flex-column">
                            <span className="fs-6" style={{ color: "#f5aa33", fontSize: "14.5px", fontWeight: 600 }}>Store</span>
                            <button className="dropdown-toggle p-1 py-2 rounded-2 d-flex gap-4 align-items-center justify-content-between" style={{ color: "#f5aa33" }} data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownstoretype">
                                {filters.store_type.default === "live" && "Live"}
                                {filters.store_type.default === "all" && "All"}
                                {filters.store_type.default === "testing" && "Testing"}
                            </button>
                            <div className="dropdown-menu p-2" aria-labelledby="dropdownstoretype">
                                {filters.store_type.list.map((store_type) => <div onClick={() => {
                                    setFilters({ ...filters, store_type: { ...filters.store_type, triger: true, default: store_type } });
                                }
                                } key={store_type} style={{ color: filters.store_type.default === store_type ? "#f5aa33" : "", cursor: "pointer" }} className="dropdown-item">
                                    {store_type === "live" && "Live"}
                                    {store_type === "all" && "All"}
                                    {store_type === "testing" && "Testing"}
                                </div>)}
                            </div>
                        </div>
                        <div className="plan-name-filter filter dropdown d-flex flex-column">
                            <span className="mb-0 fs-6" style={{ color: "#f5aa33", fontSize: "14.5px", fontWeight: 600 }}>Plan Name</span>
                            <button className="dropdown-toggle d-flex justify-content-between align-items-center p-1 py-2 rounded-2 gap-4" style={{ color: "#f5aa33" }} id="planname" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {filters.planname.list.find(plan => plan.label === filters.planname.default.label).label}
                            </button>
                            <div className="dropdown-menu p-2" aria-labelledby="planname">
                                {filters.planname.list.map((plan, index) => <div className="dropdown-item" style={{ color: plan.label === filters.planname.default.label ? "#f5aa33" : "", cursor: "pointer" }} key={index} onClick={() => {
                                    setFilters({ ...filters, planname: { ...filters.planname, default: { ...filters.planname.default, label: plan.label }, triger: true } });
                                }
                                }>{plan.label}</div>)}
                            </div>
                        </div>
                        <div className="shopify-plan-filter filter dropdown d-flex flex-column">
                            <span className="mb-0 fs-6" style={{ color: "#f5aa33", fontSize: "14.5px", fontWeight: 600 }}>Shopify Plan</span>
                            <button className="dropdown-toggle d-flex justify-content-between align-items-center p-1 py-2 rounded-2 gap-4" style={{ color: "#f5aa33" }} id="shopifyplanname" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {filters.shopifyPlan.default.label}
                            </button>
                            <div className="dropdown-menu p-2" aria-labelledby="shopifyplanname">
                                {filters.shopifyPlan.list.map((plan, index) => (
                                    <div
                                        className="dropdown-item"
                                        style={{ color: plan.value === filters.shopifyPlan.default.value ? "#f5aa33" : "", cursor: "pointer" }}
                                        key={index}
                                        onClick={() => setFilters({ ...filters, shopifyPlan: { ...filters.shopifyPlan, default: { label: plan.label, value: plan.value }, triger: true } })}
                                    >
                                        {plan.label}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="review-filter filter dropdown d-flex flex-column">
                            <span className="fs-6" style={{ color: "#f5aa33", fontSize: "14.5px", fontWeight: 600 }}>Review</span>
                            <button style={{ color: "#f5aa33" }} className="dropdown-toggle p-1 py-2 rounded-2 d-flex gap-4 align-items-center justify-content-between" id="dropdownreview" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {filters.review.default === "all" && "All"}
                                {filters.review.default === "yes" && "Yes"}
                                {filters.review.default === "no" && "No"}
                            </button>
                            <div className="dropdown-menu p-2" aria-labelledby="dropdownreview">
                                {filters.review.list.map((review, index) => <div style={{ color: filters.review.default === review ? "#f5aa33" : "", cursor: "pointer" }} className="dropdown-item" key={index} onClick={() => {
                                    setFilters({ ...filters, review: { ...filters.review, default: review, triger: true } });
                                }}>
                                    {review === "all" && "All"}
                                    {review === "yes" && "Yes"}
                                    {review === "no" && "No"}
                                </div>)}
                            </div>
                        </div>
                        <div className={filters.dates.triger ? "date-wise  position-relative d-flex flex-column align-items-start" : "date-wise position-relative"}>
                            <span style={{ color: "#f5aa33", fontSize: "14.5px", fontWeight: 600 }} className="fs-6">Dates</span>
                            <button ref={calenderDate} style={{ color: "#f5aa33" }} className="p-1 py-2 rounded-2 dropdown d-flex align-items-center justify-content-between w-100" onClick={() => setFilters({ ...filters, dates: { ...filters.dates, showCalendar: !filters.dates.showCalendar } })}>
                                {filters.dates.date.some(date => date.length > 0) > 0 ?
                                    <>
                                        <div className="position-relative d-flex gap-1 align-items-center" >
                                            <span className="label" >
                                                Start -
                                            </span>
                                            <span className="value">{filters.dates.date[0]}</span>
                                        </div>
                                        <div className="position-relative d-flex gap-1 align-items-center ">
                                            <span className="label" >End -</span>
                                            <span className="value">{filters.dates.date[1]}</span>
                                        </div>
                                    </> :
                                    <>
                                        <>
                                            Select Date Range
                                        </>
                                    </>}
                            </button>
                            {filters.dates.showCalendar && <div className="calender position-absolute" style={{ top: "78px", left: "-80px", zIndex: 10 }}>
                                <div className="calendar-container position-relative">
                                    <button className="clear-dates rounded-2 px-1" onClick={(e) => cleardatesandClose(e)}>
                                        Clear
                                    </button>
                                    <Calendar ref={calenderDate} selectRange onChange={handleDateChange} />
                                </div>
                            </div>}
                        </div>
                        <div className="trigger-filters fs-5">
                            <OverlayTrigger placement={"bottom-end"} overlay={<Tooltip>{"Trigger Search"}</Tooltip>}>
                                <button onClick={() => handleFilterSearch()} className="button-filter text-light p-2 rounded-2" style={{ backgroundColor: "#f5aa33" }}>GO</button>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 grid-box m-0">
                        <TableList tabledata={tableList} loading={filters.loader} />
                    </div>
                </div>
                {!filters.loader &&
                    <div className="row">
                        {
                            location.pathname.includes("reports") && tablerange.length > 0 &&
                            <div className="col-12 grid-box position-relative">
                                <Pagination recordsPerPage={filters.recordsPerpagedropdown} changeRecordsPerpage={changeRecordsPerpage} page={searchParamsState.get("pageNumber") ? Number(searchParamsState.get("pageNumber")) : 1} range={tablerange} slicedData={slicedData} changePage={onPageChange}    totalRecords={totalRecords}  />
                            </div>
                        }
                    </div>
                }
            </div>
        </>
    )
}
const Reports = () => {
    return (
        <Routes>
            <Route index element={<ReportsScreen />} />
            <Route path="/details" element={<StoreDetail />} />
        </Routes>
    )
}
export default Reports;